module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-250.f762428b.png";